module.exports = __webpack_public_path__ + "6474dd5ca858549361d6629f021b38c8.MP3";